/* eslint-disable max-lines */
import { map, flatten, values, get, find, remove, xorBy, clone, isFunction } from 'lodash';
import { expositions as expositionList, expositionsML as expositionListML } from './dictionaries';
import checkPublishModal from './check-publish/check-publish-modal.jade';
import { trackPayByCardModalOpen } from './payByCard.tracking';
import {
  hasPaidPackageOrPeriod,
  getPaidPackageOrPeriod,
  getDefaultPackage,
  getDefaultPeriod,
  hasPaidPackage,
  getPaidPackage,
  hasPaidPeriod,
  getPaidPeriod,
  isPackage,
  hasPackages,
  processPublishTerm,
  getNormalizedOptionName,
  isAutobrokerEnabled,
  getDaysNoun,
  isAdditionalTermCompatible,
  setOptionTab,
  isAutoprolongAvailable,
  getCurrentPeriodFromSelected,
  getRecommendedPackages,
  isSubscriptionOption,
  getServicePackageName,
  getClientDeviceType,
  getDiffPricing,
} from './utils';
import { trackOptionClick } from './tracking';
import { selectConfigValue } from '../../../shared/selectors/config';
import {
  selectDynamicPricingParameters,
  selectIsArchived,
  selectIsByHomeowner,
  selectIsFromXml,
  selectOfferCategory,
  selectOfferId,
} from '../../../shared/selectors/offer';
import { mapMultiposting } from '../../../shared/services/publishTerms/getPublishTerms/utils/mapMultiposting';
import { getIsCommercial } from '../../../shared/utils/category/getIsCommercial';
import { ca } from '@cian/analytics';
import { selectAnalyticsFormId, selectAnalyticsOfferStatus } from '../../../shared/selectors/analytics';
import { trackDiffPricingShow, trackServicesShow } from './publishTermsTracking';

export default [
  '$rootScope',
  '$http',
  '$q',
  '$uibModal',
  'placingTermsConfig',
  'popupService',
  'userService',
  'analyticsService',
  'addFormService',
  'deviceService',
  'hiddenBaseService',
  'store',
  'telemetryService',
  '$document',
  'formIdService',
  function (
    $rootScope,
    $http,
    $q,
    $uibModal,
    placingTermsConfig,
    popupService,
    userService,
    analyticsService,
    addFormService,
    deviceService,
    hiddenBaseService,
    store,
    telemetryService,
    $document,
    formIdService,
  ) {
    const self = this;
    const fireTermsChanged = () => $rootScope.$emit('terms.changed');

    const state = store.getState();
    const offerId = selectOfferId(state);
    const isFromArchive = selectIsArchived(state);
    const isFromXML = selectIsFromXml(state);
    const analyticsOfferStatus = selectAnalyticsOfferStatus(state);
    const analyticsFormId = selectAnalyticsFormId(state);

    const { isMobile } = deviceService;

    let currentParams;
    let currentTerms;
    let currentOption;
    let userHasChangedServices;
    let additionalData = {};
    let apiDeffered;

    this.terms = {};
    this.publishTerms = {};
    this.placingTerms = [];
    this.loadedPlacingTerms = {};
    this.isCalltrackingAvailable = false;
    this.isAuctionAvailable = false;
    this.auctionProgressTermNames = [];

    // Если true - пользак хочет получить помощь риэлтора (отправляем заявку в спрос)
    this.isRealtorHelpNeeded = false;

    // Выбранные опции
    this.selected = {
      option: {},
      additionals: [],
    };

    this.setTerms = (terms, isAfterUpdate) => {
      currentTerms = clone(terms);
      userHasChangedServices = !isAfterUpdate;
    };

    this.resetTerms = () => {
      this.terms.bundles = [];
      this.terms.additionals = [];
      this.terms.errorMessage = undefined;
      this.terms.isAvailable = undefined;
      this.terms.autoProlong = undefined;
      this.terms.isHighDemand = undefined;
      this.terms.highDemandCoefficient = undefined;
      this.terms.diffPricing = { iterationId: null, granuleGuid: null };
      this.auctionOption = undefined;

      this.isCalltrackingAvailable = false;
      this.isAuctionAvailable = false;
    };

    this.resetTerms();

    // Выбрана услуга, например "Премиум", услуга рендерится как радио
    this.isSelected = option => {
      if (!currentOption && option === this.selected.option) {
        currentOption = option;
      }

      return option.id === this.selected.option?.id;
    };

    // Выбрана опция, например "Выделение цветом", опция рендерится как чекбокс
    this.isAdditionalSelected = additional => {
      return !this.isDisabled(additional) && this.selected.additionals.includes(additional);
    };

    this.isDisabled = option => {
      // Если вариант отключен по какой-то причине
      if (option && !option.isAvailable) {
        return true;
      }

      // Если доп. опция отключена для выбранного варианта
      if (option && option.isAdditional) {
        return !isAdditionalTermCompatible(option, this.selected.option);
      }

      return false;
    };

    this.isAdditionalCompatible = isAdditionalTermCompatible;

    this.getAllSelectedServices = () => [this.selected.option, ...this.selected.additionals];

    // Срабатывает при выборе опции
    this.selectOption = (option, useXor = true) => {
      if (!this.isDisabled(option)) {
        trackOptionClick(option.id, analyticsService.adAnalyticsCategory);
        // Если выбирается дополнительная опция
        if (option.isAdditional) {
          // Если основная услуга оплачена
          if (this.selected.option.selectedPeriod.isPaid) {
            // Если есть оплаченная дополнительная услуга, то это услуги(основная и дополнительная) куплены вместе
            if (hasPaidPackageOrPeriod(option)) {
              this.setSelectedPeriodForOption(option, getPaidPackageOrPeriod(option));
            }
            // Если нет оплаченной доп.услуги
            else {
              // Если доступны пакеты, выбираем дефолтный пакет
              if (hasPackages(option)) {
                this.setSelectedPeriodForOption(option, getDefaultPackage(option));
              }
              // Так как основная услуга уже оплачена, и нет оплаченной доп.услуги, тогда доп.услуга подключается посуточно
              else {
                this.setSelectedPeriodForOption(option, getDefaultPeriod(option));
              }
            }
          }
          // Если основная услуга не оплачена
          else {
            // Если есть пакеты, выбираем дефолтный пакет
            if (hasPackages(option)) {
              this.setSelectedPeriodForOption(option, getDefaultPackage(option));
            }
            // Иначе для доп.услуги выбираем период с ключом равным основной услуге
            else {
              this.setSelectedPeriodForOption(
                option,
                getDefaultPeriod(option, this.selected.option.selectedPeriod.key),
              );
            }
          }

          // Инвертируем выбор доп. опции
          if (useXor) {
            this.selected.additionals = xorBy(this.selected.additionals, [option], 'id');
          }
        } else {
          this.selected.option = option;

          this.updateAdditionals(option);
          // Обновляем шаг ставки после выбора другого VAS
          this.updateBetData();
        }

        // Если this.selectOption вызыван из updateAdditionals, то useXor = false
        // И fireTermsChanged будет вызван после изменения основной опции, и здесь его надо пропустить
        if (useXor) {
          fireTermsChanged();
        }
      }
    };

    /** Добавляет в список выделенных дополнительную услугу, если она не в списке */
    this.selectAdditional = additional => {
      if (!this.isAdditionalSelected(additional)) {
        this.pushAdditional(additional);
      }
    };

    /** Добавляет дополнительную услугу в список выделенных */
    this.pushAdditional = additional => this.selected.additionals.push(additional);

    /** Возвращает объект услуги по id */
    this.getOptionById = optionId => {
      if (!this.placingTerms || !this.placingTerms.length) {
        return;
      }

      return this.placingTerms.find(({ id }) => id === optionId);
    };

    // Actions

    this.selectPaidPackageOrPeriod = option => {
      if (hasPaidPackage(option)) {
        option.selectedPeriod = getPaidPackage(option);

        setOptionTab(option, 0);
      } else if (hasPaidPeriod(option)) {
        option.selectedPeriod = getPaidPeriod(option);

        setOptionTab(option, 1);
      }
    };

    this.setSelectedPeriodForOption = (option, selectedPeriod) => {
      option.selectedPeriod = selectedPeriod;

      const activeTab = isPackage(selectedPeriod) ? 0 : 1;

      setOptionTab(option, activeTab);
    };

    this.updateAdditionals = option => {
      this.terms.additionals.forEach(additional => {
        if (isAdditionalTermCompatible(additional, option)) {
          const additionalPaidPeriod = getPaidPeriod(additional);

          if (additionalPaidPeriod) {
            // Если есть оплаченный период, выбираем его
            additional.selectedPeriod = additionalPaidPeriod;

            this.selectAdditional(additional);
          }
        } else {
          this.removeAdditionalById(additional.id);
        }
      });
    };

    this.removeAdditionalById = id => {
      remove(this.selected.additionals, { id });

      fireTermsChanged();
    };

    this.selectPeriod = option => {
      if (option.isAdditional) {
        fireTermsChanged();
      } else if (option === this.selected.option) {
        this.updateAdditionals(option);
        fireTermsChanged();
      }
    };

    // Возвращает {type, data} объект в случае, если пришла ошибка от бекенда или undefined, если ошибок нет.
    const getErrorMessageData = messages => {
      // TODO добавить в sentry логирование ситуаций, когда в message от бекенда придёт больше одного не null свойства.
      return map(messages, (v, k) => ({ type: k, data: v })).filter(message => message.data)[0];
    };

    const processTerms = currentParams => {
      const previousTerms = flatten(values(this.terms));
      const selectedAdditionals = [];

      const state = store.getState();
      const category = selectOfferCategory(state);
      const isByHomeowner = selectIsByHomeowner(state);

      this.resetTerms();

      this.terms.errorMessage = this.errorMessage;
      this.terms.isAvailable = this.placingTerms.length > 0;
      this.terms.autoProlong = this.autoProlong;
      this.terms.isHighDemand = this.isHighDemand;
      this.terms.highDemandCoefficient = this.highDemandCoefficient;
      this.terms.diffPricing = getDiffPricing(this.placingTerms);

      let previouslySelectedOption;
      let paidOption;
      let defaultOption;

      if (
        // тип объекта — гараж
        category?.indexOf('garage') > -1 ||
        // пользователь собственник
        isByHomeowner
      ) {
        // убираем из васов Подписку
        this.placingTerms = this.placingTerms.filter(({ services }) => !services.includes('servicePackage'));
      }

      this.placingTerms = this.placingTerms.map(item => {
        const id = item.services.join('+');

        const newItem = {
          ...item,
          id,
        };

        // Default option
        if (newItem.isDefault && !newItem.isAdditional) {
          defaultOption = newItem;
        }

        // Если опция была выбрана до обновления данных
        if (this.selected.option && newItem.isAvailable && newItem.id === this.selected.option.id) {
          previouslySelectedOption = newItem;
        }

        const packages = newItem.publishOptions.servicePackages;
        const periods = newItem.publishOptions.periods;

        // Распределяем по группам
        if (newItem.services.length > 1) {
          newItem.isBundle = true;
        } else if (newItem.isAdditional) {
          this.terms.additionals.push(newItem);
        }

        // Обрабатываем периоды
        let selectedPayOption;
        let defaultPeriodsOption;
        let paidPayOption;
        // TODO вот здесь надо понимать был выбран период или пакет
        const previouslySelectedPayOption = get(find(previousTerms, { id: newItem.id }), 'selectedPeriod');

        if (hasPackages(newItem) && hasPaidPackage(newItem)) {
          if (newItem.isAdditional) {
            selectedAdditionals.push(newItem);
          } else {
            paidOption = newItem;
            paidPayOption = getPaidPackage(newItem);
          }
        } else {
          periods.forEach(payOption => {
            payOption.text =
              payOption.type === 'dailyTermless' ? 'Бессрочно' : `${payOption.days} ${getDaysNoun(payOption.days)}`;
            // TODO использовать ng-pluralize, когда будет поддержка компиляции директив в дропдауне
            // https://cianru.atlassian.net/browse/CSSSR-850
            // period.text = `<ng-pluralize count="${period.days}" when="{'one': '{} день', 'few': '{} дня', 'many': '{} дней'}"></ng-pluralize>`;

            // Сохраняем выбор периода
            if (previouslySelectedPayOption && payOption.key === previouslySelectedPayOption.key) {
              selectedPayOption = payOption;
            }

            if (payOption.isDefault) {
              defaultPeriodsOption = payOption;
            }

            if (payOption.isPaid) {
              if (newItem.isAdditional) {
                selectedAdditionals.push(newItem);

                const phoneObject = get($rootScope, 'savedAd.phones[0]');

                if (id === 'calltracking' && phoneObject) {
                  $rootScope.ad.replacedPhone = phoneObject['countryCode'] + phoneObject['number'];
                }
              } else {
                paidOption = newItem;
              }

              paidPayOption = payOption;
            }

            // Преобразуем цену в цифру
            payOption.marketingPrice = Number(String(payOption.marketingPrice).replace(',', '.'));
            payOption.price = Number(String(payOption.price).replace(',', '.'));
          });
        }

        // Если есть периоды и пакеты, показываем табы
        const optionHasPeriods = Boolean(periods.length);
        const optionHasPackages = Boolean(packages.length);
        newItem.hasTabs = optionHasPeriods && optionHasPackages;

        const arePeriodsSelected = periods.some(option => option.isPaid);

        if (newItem.hasTabs) {
          // если есть оплаченый период, показываем таб с периодами
          // иначе показываем таб с пакетами
          newItem.activeTab = arePeriodsSelected ? 1 : 0;
        }

        // Приоритет выбора периода/пакета для опции:

        if (optionHasPackages && !arePeriodsSelected) {
          newItem.selectedPeriod = packages.find(option => option.isPaid) || packages[0];
        } else {
          newItem.selectedPeriod =
            // 1. Оплаченный
            paidPayOption ||
            // 2. Выбранный до обновления данных
            selectedPayOption ||
            // 3. Дефолтный
            defaultPeriodsOption ||
            // 4. Первый попавшийся
            periods[0];
        }

        const mlRegions = selectConfigValue('mlOffersRankingEnabledRegions', state);

        if (
          currentParams &&
          currentParams.locationPath &&
          Array.isArray(mlRegions) &&
          mlRegions.some(region => currentParams.locationPath.includes(region))
        ) {
          newItem.exposition = expositionListML[newItem.id];
        } else {
          newItem.exposition = expositionList[newItem.id];
        }

        switch (true) {
          case id === 'calltracking':
            this.isCalltrackingAvailable = true;
            this.calltrackingOption = newItem;

            break;

          case id === 'auction':
            this.isAuctionAvailable = true;

            // Аукционный isAvailable означает активность ставки на аккаунт
            newItem.isAuctionBetHolded = !newItem.isAvailable;
            // Многие функции услуг завязаны на доступность опции.
            // С аукционами мы договорились, что они доступны, если в publish-terms приходит услуга «auction».
            // Чтобы не дублировать функции проверки услуг, записываем значение isAvailable в isAuctionBetHolded,
            // isAvailable устанавливаем в true.
            newItem.isAvailable = true;
            newItem.sourceBet = newItem.selectedPeriod.price;

            const { auctionInfo } = newItem;

            this.auctionMinBet = auctionInfo ? auctionInfo.minimalBet : 1;
            this.auctionMaxBet = auctionInfo ? auctionInfo.maximalBet : 99;

            this.configurations = (auctionInfo && auctionInfo.configurations) || [];

            this.isAutobrokerEnabled = isAutobrokerEnabled(newItem);

            const serviceCosts = auctionInfo && auctionInfo.serviceCosts;

            this.auctionProgressTermNames = [];
            this.auctionProgressTermCosts = [];

            if (serviceCosts) {
              serviceCosts.forEach(({ serviceTypes, cost }) => {
                this.auctionProgressTermNames.push(serviceTypes.join('+'));
                this.auctionProgressTermCosts.push(Number(cost));
              });
            }

            this.auctionOption = newItem;

            break;

          case id === 'servicePackage':
            const recommendedPackages = getRecommendedPackages(newItem);
            const recommendedPackage = recommendedPackages[0];

            if (recommendedPackage) {
              recommendedPackage.marketingPrice = recommendedPackage.totalMarketingPrice;
              recommendedPackage.price = recommendedPackage.totalPrice;
              recommendedPackage.recommendedServicePackageId = recommendedPackage.id;
              recommendedPackage.name = getServicePackageName(recommendedPackage);

              newItem.selectedPeriod = recommendedPackage;
            }

            break;
        }

        return newItem;
      });

      const getFirstAvailable = () =>
        this.placingTerms.find(({ isAdditional, isAvailable }) => !isAdditional && !!isAvailable);

      // Приоритет выбора услуги:
      const selectedOption =
        // 1. Оплаченная
        paidOption ||
        // 2. Выбранная до обновления данных
        previouslySelectedOption ||
        // 3. Услуга по умолчанию
        defaultOption ||
        // 4. Первая доступная
        getFirstAvailable() ||
        // 5. Фолбэк — пустая услуга
        {};

      this.selected.option = selectedOption;
      this.selected.additionals = selectedAdditionals;

      // Обновляем шаг ставки для выбранного VAS
      this.updateBetData();
    };

    /** Обновляет шаг ставки для текущего выбранного VAS */
    this.updateBetData = () => {
      const selectedOption = this.selected.option && this.selected.option.id;

      // Конфигурации содержат шаги ставок для каждого VAS
      const config = (this.configurations || []).find(
        config => getNormalizedOptionName(config.serviceTypes) === selectedOption,
      );

      this.stepBet = (config && config.stepBet) || 5;
      this.auctionMinBet = this.stepBet;
    };

    this.isCalltrackingSelected = () => this.isAdditionalSelected(this.calltrackingOption);

    this.trackPublishTermsShow = () => {
      const allowedVASList = this.placingTerms || [];
      const serviceIds = allowedVASList.map(option => option.id);
      const deviceType = getClientDeviceType();

      trackServicesShow({ analyticsOfferStatus, serviceIds, analyticsFormId, deviceType });

      const { iterationId, granuleGuid } = this.terms.diffPricing;

      if (!!iterationId || !!granuleGuid) {
        trackDiffPricingShow({
          analyticsOfferStatus,
          analyticsFormId,
          diffPriceIterationId: iterationId,
          diffPriceGranuleGuid: granuleGuid,
        });
      }
    };

    /**
     * Валидация ставки аукциона.
     *
     * @param {number} ставка
     * @param {number} шаг ставки
     * @param {boolean} валидировать ли шаг ставки
     *
     * @returns {string} тип ошибки
     * @returns {null} неизвестная ошибка
     * @returns {undefined} ошибки нет
     */
    this.auctionBetValidate = (price, step, validateStep) => {
      if (
        // Аукцион недоступен
        !this.auctionOption ||
        // Ставка не установлена
        !price ||
        // Есть удержание ставки на аккаунт
        this.auctionOption.isAuctionBetHolded ||
        // Ставка 0 ₽
        price === 0
      ) {
        return;
      }

      switch (true) {
        // Ставка меньше минимальной
        case price < this.auctionMinBet:
          return 'min';

        // Ставка больше максимальной
        case price > this.auctionMaxBet:
          return 'max';

        // Ставка не кратна шагу ставки
        case validateStep && price % step !== 0:
          return 'multiple';

        default:
          return null;
      }
    };

    this.updateTerms = (params = currentParams) => {
      currentParams = params;

      this.onStartLoading();

      if (apiDeffered) {
        apiDeffered.resolve();
      }

      apiDeffered = $q.defer();

      const requestParams = {
        allowServerErrors: true,
        isFromArchive,
        ...params,
        ...additionalData,
      };

      if (!isFromXML) {
        requestParams['id'] = offerId;
      }

      telemetryService.mark('terms.publish-terms-start');

      $http
        .post('/addform/v5/publish-terms/', requestParams, {
          timeout: apiDeffered.promise,
        })
        .then(
          result => {
            telemetryService.mark('terms.publish-terms-end');
            telemetryService.sendMeasuredTimer(
              'terms.publish-terms-request',
              'terms.publish-terms-start',
              'terms.publish-terms-end',
            );

            if (params.category === result.config.data.category) {
              const { isMultipostingAvailable, multipostingABGroup } = mapMultiposting(result.data.data);

              this.placingTerms = result.data.data.terms;
              this.autoProlong = result.data.data.autoProlong;
              this.isHighDemand = result.data.data.isHighDemand;
              this.highDemandCoefficient = result.data.data.highDemandCoefficient;
              this.loadedPlacingTerms = clone(result.data.data.terms);
              this.errorMessage = getErrorMessageData(result.data.data.message);
              this.isMultiPostingAvailable = isMultipostingAvailable;
              this.multipostingABGroup = multipostingABGroup;

              processTerms(currentParams);

              this.onSuccess(this.placingTerms);
            }
          },
          () => {
            this.resetTerms();
            this.onFail();
          },
        );
    };

    this.backTerms = () => {
      this.placingTerms = clone(this.loadedPlacingTerms);
      this.selected.option = {};
      this.selected.additionals = [];
      processTerms();
      this.onSuccess();
    };

    const prepareCheckParams = () => {
      const { replacedPhone, calltrackingPhone, bargainTerms, totalArea, category, areaParts } = addFormService.ad;

      const state = store.getState();
      const extraData = selectDynamicPricingParameters(state);

      const params = {
        ...additionalData,
        locationPath: (currentParams.locationPath && currentParams.locationPath.join(',')) || undefined,
        category: currentParams.category || undefined,
        userHasChangedServices,
        ...currentTerms,
        latitude: currentParams.latitude,
        longitude: currentParams.longitude,
        userHasChangedCalltrackingPhone: replacedPhone !== calltrackingPhone,
        isFromArchive,
        extraData,
      };

      const isCommercial = !!category && getIsCommercial(category);

      if (isCommercial) {
        Object.assign(params, {
          price: bargainTerms && bargainTerms.price,
          currency: bargainTerms && bargainTerms.currency,
          priceType: bargainTerms && bargainTerms.priceType,
          paymentPeriod: bargainTerms && bargainTerms.paymentPeriod,
          totalArea,
          multiListingSlotsCount: areaParts?.length ?? null,
        });
      }

      if (!isFromXML) {
        params['objectId'] = offerId;
      }

      if (typeof currentParams.isMultiListing === 'boolean') {
        params['isMultiListing'] = currentParams.isMultiListing;
      }

      return params;
    };

    this.checkPublish = function (onConfirm, onSkip, config) {
      if (!onSkip) {
        onSkip = onConfirm;
      }

      const requestParams = prepareCheckParams();

      this.checkPublishLoading = true;

      const req = $http.post(placingTermsConfig.checkPublishApi, requestParams, config);

      // todo: переместить вызов apiFactory.checkPublish и открытие модала в отдельный сервис checkPublishService
      telemetryService.mark('terms.check-publish-start');

      return req
        .then(({ data }) => {
          telemetryService.mark('terms.check-publish-end');
          telemetryService.sendMeasuredTimer(
            'terms.check-publish-request',
            'terms.check-publish-start',
            'terms.check-publish-end',
          );

          if (data.type == 'Warning' || data.type == 'Blocked') {
            const modalWrapper = document.querySelector('.modal-wrapper');
            const $modalWrapper = angular.element(modalWrapper);

            const mobileModalConfig = isMobile && {
              appendTo: $modalWrapper,
              openedClass: 'modal-open',
            };

            const modalInstance = $uibModal.open({
              template: checkPublishModal,
              controller: [
                'params',
                function (params) {
                  this.params = params;
                },
              ],
              controllerAs: 'c',
              resolve: {
                params: () => ({ data, onConfirm }),
              },
              ...mobileModalConfig,
            });

            if (isMobile) {
              $modalWrapper.addClass('modal-open');
              $document.find('body').addClass('modal-body-wrapper');
            }

            modalInstance.closed.finally(() => {
              if (isMobile) {
                $modalWrapper.removeClass('modal-open');
                $document.find('body').removeClass('modal-body-wrapper');
              }
            });

            return true;
          } else {
            onSkip();
          }
        })
        .finally(() => (this.checkPublishLoading = false));
    };

    let checkServiceTimeout;

    // проверка доступности выбранных услуг
    // http://master.bill.test.cian.ru/swagger/ui/index#!/AnnouncementWebApi/AnnouncementWebApi_CheckService
    this.checkService = function () {
      self.onCheckServiceRequestStart();
      this.checkServiceLoading = true;

      const params = prepareCheckParams();

      this.cancelCheckServiceRequest();

      const paramsTerms = get(params, 'terms', []);

      if (paramsTerms.length === 0) {
        this.checkServiceLoading = false;
        this.checkServiceData = null;

        return Promise.reject();
      }

      checkServiceTimeout = $q.defer();

      telemetryService.mark('terms.check-service-start');

      const req = $http
        .post(placingTermsConfig.checkServiceApi, params, { timeout: checkServiceTimeout.promise })
        .then(res => {
          telemetryService.mark('terms.check-service-end');
          telemetryService.sendMeasuredTimer(
            'terms.check-service-request',
            'terms.check-service-start',
            'terms.check-service-end',
          );
          self.onCheckServiceRequestFinish({ $success: res.status === 200 });

          return res;
        })
        .catch(err => {
          if (err && err.status !== -1) {
            self.onCheckServiceRequestFinish({ $success: false });
          }

          return $q.reject(err);
        });
      // Когда мы запускаем функцию checkService мы выполняем функцию cancelCheckServiceRequest
      // Она резолвит промис таймаута checkServiceTimeout, и отменяется выполнение текущего запроса, далее продолжается поток выполнения
      // Записывается новый промис в checkServiceTimeout
      // В это время асинхронно вызывается метод finally, который перетирает значение уже нового промиса checkServiceTimeout
      // И получается что checkServiceTimeout уже не содержит значение нового промиса, и отменить мы его не сможем
      // Каждый второй запрос не отменяется
      // Эта строка не нужна
      // .finally(() => checkServiceTimeout = undefined);

      // мок, имитируем недоступность при наличии автопродления, фейл запроса - при наличии ВЦ
      // const mock = { ...require('./api-factory-mock').checkServiceMock, isAvailable: !currentTerms.autoprolong };
      // const failReq = currentTerms.terms.find(t => t.services.includes('highlight'));
      // const req = $timeout(() => ({data: !failReq ? mock : undefined}), 1000);

      return req
        .then(response => {
          if (!response.data) {
            throw 'check-service: неправильный формат ответа';
          }

          return (this.checkServiceData = response.data);
        })
        .catch(e => {
          if (e && e.status !== -1) {
            this.checkServiceData = null;
          }

          return $q.reject(e);
        })
        .finally(() => {
          this.checkServiceLoading = false;
        });
    };

    // отмена последнего запроса к чек-сервису
    this.cancelCheckServiceRequest = () => {
      if (checkServiceTimeout) {
        checkServiceTimeout.resolve();
      }
    };

    this.setAdditionalData = input => {
      additionalData = input;
    };

    this.isNotEnoughMoney = false;
    this.totalPriceAmount = 0;

    this.shouldPayByCard = () => {
      const canPayByCard = userService.user.canPayByCard || false;
      const isInHiddenBase = hiddenBaseService.isEnabled();

      return !isInHiddenBase && canPayByCard && this.isNotEnoughMoney;
    };

    this.setNotEnoughMoney = value => {
      this.isNotEnoughMoney = value;
    };

    this.setTotalPriceAmount = value => {
      this.totalPriceAmount = value;
    };

    this.setIsHidden = value => {
      this.isHidden = value;
    };

    this.getTotalPriceAmount = () => this.totalPriceAmount;
    this.getIsHidden = () => this.isHidden;

    this.showRefillAccountPopup = (source, amount = undefined) => {
      popupService.openPopup('payByCard', { options: { source, amount } });

      trackPayByCardModalOpen(source, analyticsService.adAnalyticsCategory);
    };

    this.isAutoprolongAvailable = () => {
      return isAutoprolongAvailable(this.checkServiceData);
    };

    this.getCurrentPeriodFromSelected = () => getCurrentPeriodFromSelected(this.selected);

    this.processPublishTerm = processPublishTerm;
    this.isSubscriptionOption = isSubscriptionOption;

    this.init = ({ onStartLoading, onSuccess, onFail, onCheckServiceRequestStart, onCheckServiceRequestFinish }) => {
      this.resetTerms();

      this.onStartLoading = onStartLoading;
      this.onSuccess = onSuccess;
      this.onFail = onFail;

      this.onCheckServiceRequestStart = isFunction(onCheckServiceRequestStart) ? onCheckServiceRequestStart : () => {};

      this.onCheckServiceRequestFinish = isFunction(onCheckServiceRequestFinish)
        ? onCheckServiceRequestFinish
        : () => {};
    };

    return this;
  },
];
